import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { RouteType } from "../models/enum";
import { RoleService } from "../shared/services/role.service";
import { GoogleAuthService } from "./google-api.service";

@Injectable({
	providedIn: "root",
})
export class GroupAdminOrAdminGuard {
	constructor(
		private router: Router,
		private roleService: RoleService,
		private authService: GoogleAuthService,
	) {}

	async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
		const allowed = (): boolean => this.roleService.isAdmin || this.roleService.isGroupAdmin;

		if (!navigator.onLine) {
			if (this.authService.hasValidOfflineSession() && allowed()) {
				return true;
			}
			this.router.navigate([this.roleService.getDefaultRoute?.() ?? RouteType.DASHBOARD]);
			return false;
		}

		const authenticated = await this.authService.ensureSessionResolved();
		if (authenticated && allowed()) {
			return true;
		}

		this.router.navigate([this.roleService.getDefaultRoute?.() ?? RouteType.DASHBOARD]);
		return false;
	}
}
